import React from 'react';
import { connect } from 'react-redux';

import { COOKIE_KEY_REDIRECT_AFTER_LOGIN } from '../../../constants/cookie';

import { LoadingComponent } from '../../loading/LoadingComponent';
import LoginButton from '../../header/membernav/LoginButton';

import './LoggedOutModal.scss';

class LoggedOutModal extends React.Component {
    componentDidMount() {
        const { currentPath } = this.props;

        // Mémorise le chemin courant pour y revenir après connexion
        if (currentPath) {
            sessionStorage.setItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN, currentPath);
        }
    }

    render() {
        const { i18n, fetching } = this.props;

        return fetching ? (
            <div className="modal-logged-out">
                <div className="container-header">{i18n.LOGIN_FETCHING}</div>
                <div className="container-body">
                    <LoadingComponent />
                    <div className="container-button"></div>
                </div>
            </div>
        ) : (
            <div className="modal-logged-out">
                <div className="container-header">{i18n.HEADER}</div>
                <div className="container-body">
                    <p>{i18n.TEXT_1}</p>
                    <p>{i18n.TEXT_2}</p>
                    <div className="container-button">
                        <LoginButton />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.LOGGED_OUT_MODAL,
        fetching: state.authentication.fetching
    };
};

export default connect(mapStateToProps)(LoggedOutModal);



// WEBPACK FOOTER //
// ./src/components/authentication/loggedout/LoggedOutModal.js